export default __webpack_public_path__ + "static/media/shopping_cart_icon.a49a7919.svg";